import { APP_URL, CONTACT_EMAIL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';
import { asset } from '../../lib/asset';

function Footer() {
    const { t } = useLanguage();
    const year = new Date().getFullYear();

    return (
        <footer>
            <div className="wrap">
                <div className="foot">
                    <div>
                        <img src={asset('apc-plus-logo.png')} alt="APC Plus" width="900" height="273" />
                        <p style={{ maxWidth: '22rem' }}>{t.footerBlurb}</p>
                    </div>
                    <div>
                        <h4>{t.footerExplore}</h4>
                        <ul>
                            <li>
                                <a href="#what">{t.howItWorks}</a>
                            </li>
                            <li>
                                <a href="#everyday">{t.navShopTravel}</a>
                            </li>
                            <li>
                                <a href="#red-packets">{t.navPackets}</a>
                            </li>
                            <li>
                                <a href="#rewards">{t.footerCashback}</a>
                            </li>
                            <li>
                                <a href="#trust">{t.footerSafety}</a>
                            </li>
                            <li>
                                <a href="#roadmap">{t.navRoadmap}</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h4>APC Plus</h4>
                        <ul>
                            <li>
                                <a href={APP_URL}>{t.footerOpenApp}</a>
                            </li>
                            <li>
                                <a href={APP_URL}>{t.footerBrowse}</a>
                            </li>
                            <li>
                                <a href={APP_URL}>{t.footerWallet}</a>
                            </li>
                            <li>
                                <a href="#advanced">{t.footerAdvanced}</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h4>{t.footerContact}</h4>
                        <ul>
                            <li>
                                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="legal">
                    <span>
                        © {year} APC TECHNOLOGY SDB BHD. {t.trademark}
                    </span>
                    <span>{t.footerLegalNote}</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
